import { Link } from "react-router-dom";
import Reveal from "../components/Reveal";
import { SERVICES } from "../data/content";

export default function Services() {
  return (
    <section data-testid="services-section" className="relative">
      <div className="container-x section-y">
        <Reveal>
          <div className="mb-12 flex items-end justify-between">
            <div>
              <span className="overline">What We Do</span>
              <h2 className="mt-4 font-playfair text-3xl font-bold tracking-tight sm:text-4xl lg:text-5xl">
                A full-spectrum studio
              </h2>
            </div>
            <Link to="/services" data-testid="view-all-services" className="hidden text-sm text-neutral-400 transition-colors hover:text-gold sm:block">
              All services →
            </Link>
          </div>
        </Reveal>

        <div className="grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <Reveal key={s.id} delay={i * 0.05}>
              <Link
                to="/services"
                data-testid={`service-card-${s.id}`}
                className="group relative block aspect-[4/5] overflow-hidden"
              >
                <img
                  src={s.image}
                  alt={s.title}
                  loading="lazy"
                  className="h-full w-full object-cover brightness-[0.55] transition-all duration-700 ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-105 group-hover:brightness-90"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent" />
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <span className="text-xs uppercase tracking-[0.25em] text-gold">0{i + 1}</span>
                  <h3 className="mt-2 font-playfair text-2xl text-white lg:text-3xl">{s.title}</h3>
                  <p className="mt-1 text-sm font-light text-neutral-300">{s.short}</p>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
